import { render } from "./KeyboardButton.vue?vue&type=template&id=5514bb5b&scoped=true"
import script from "./KeyboardButton.vue?vue&type=script&lang=js"
export * from "./KeyboardButton.vue?vue&type=script&lang=js"

import "./KeyboardButton.vue?vue&type=style&index=0&id=5514bb5b&scoped=true&lang=css"

import exportComponent from "/Users/vaclavsmital/Projects/geoword/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5514bb5b"]])

export default __exports__